// @ts-nocheck
import { Overlay } from '@angular/cdk/overlay';
import { NgClass, NgTemplateOutlet } from '@angular/common';
import {
  Component,
  ElementRef,
  EventEmitter,
  HostBinding,
  Input,
  OnDestroy,
  OnInit,
  Output,
  TemplateRef,
  ViewChild,
  forwardRef,
  inject,
} from '@angular/core';
import { IconComponent } from '@lbca-shared/icon';
import moment from 'moment';
import {
  always as alwaysRamda,
  clone as cloneRamda,
  filter as filterRamda,
  flatten as flattenRamda,
  has as hasRamda,
  ifElse as ifElseRamda,
  isEmpty as isEmptyRamda,
  isNil as isNilRamda,
  map as mapRamda,
  pathOr as pathOrRamda,
  pipe as pipeRamda,
  prop as propRamda,
  reduce as reduceRamda,
} from 'ramda';
import { v1 as uuidV1 } from 'uuid';
import { waitingTimer } from '../../../../helpers/_old_helpers/animate';
import { USER_SERVICE, UserServiceInterface } from '../../../../services/user.services';
import { DepositsPanelComponent } from '../../deposits-panel/deposits-panel.component';
import { DynamicFormService } from '../../dynamic-form/dynamic-form.service';
import { FileUploadComponent } from '../../dynamic-form/sub-modules/file-upload/file-upload.component';
import { EntityFieldsComponent } from '../../dynamic-form/sub-modules/sub-form/entity-fields/entity-fields.component';
import { ErrorOverlayClass } from '../../error-overlay/error-overlay.directive';
import {
  PopupFeedbackDirective,
  PopupInterfaceCommunication,
} from '../../popup-feedback/popup-feedback.directive';
import { TableCondensedComponent } from '../../table-condensed/table-condensed.component';
import { AdditionalValuesComponent } from '../additional-values/additional-values.component';
import { DatePickerComponent } from '../date-picker/date-picker.component';
import { DateTimePickerComponent } from '../date-time-picker/date-time-picker.component';
import { FileFromProcessComponent } from '../file-from-process/file-from-process.component';
import { GridboxUniqueComponent } from '../gridbox-unique/gridbox-unique.component';
import { InputHiddenComponent } from '../input-hidden/input-hidden.component';
import { InputReferenceComponent } from '../input-reference/input-reference.component';
import { InputTextComponent } from '../input-text/input-text.component';
import { SelectTreeComponent } from '../select-tree/select-tree.component';
import { TextareaComponent } from '../textarea/textarea.component';
import { TimePickerRefComponent } from '../timepicker/timepicker.component';
import { FieldsGrid } from './grid.model';
import { GridBoxService } from './gridbox.service';

@Component({
  selector: 'lbca-gridbox',
  templateUrl: './gridbox.component.html',
  styleUrl: './gridbox.component.scss',
  imports: [
    forwardRef(() => DepositsPanelComponent),
    NgTemplateOutlet,
    NgClass,
    forwardRef(() => GridboxUniqueComponent),
    forwardRef(() => GridboxComponent),
    forwardRef(() => InputHiddenComponent),
    forwardRef(() => InputTextComponent),
    forwardRef(() => DatePickerComponent),
    forwardRef(() => TimePickerRefComponent),
    forwardRef(() => DateTimePickerComponent),
    forwardRef(() => EntityFieldsComponent),
    forwardRef(() => TextareaComponent),
    forwardRef(() => FileUploadComponent),
    forwardRef(() => AdditionalValuesComponent),
    IconComponent,
    forwardRef(() => SelectTreeComponent),
    forwardRef(() => InputReferenceComponent),
    forwardRef(() => TableCondensedComponent),
    forwardRef(() => FileFromProcessComponent),
  ],
})
export class GridboxComponent implements OnInit, OnDestroy {
  private overlay = inject(Overlay);
  private elementRef = inject(ElementRef);
  private gridBoxService = inject(GridBoxService);

  private popupFeedController = new PopupInterfaceCommunication();

  @HostBinding('attr.lbcaPopupFeedback') popupFeedback = new PopupFeedbackDirective(
    this.overlay,
    this.popupFeedController
  );

  @ViewChild('mainElement', { static: true }) mainElement!: ElementRef;
  @ViewChild('templateRemove') templateRemove!: TemplateRef<any>;
  @ViewChild('templateCopy') templateCopy!: TemplateRef<any>;
  @ViewChild('actionsRender', { static: true }) actionsRender!: ElementRef;
  @ViewChild('delete_count', { static: true }) delete_count!: ElementRef;
  dataGrid: any[] = [];
  error!: any;
  gridFormModuleInstance = null;
  disabedControll = false;

  private fieldItem: any;
  private fieldConfiguration: any;
  private templateData: any;
  public templateConfig: any = {
    canAdd: 'true',
    canDelete: 'true',
    canEdit: 'true',
  };

  public fieldList: any[] = [];

  public table: { config: any; body: any[]; columns?: any; details?: any } = {
    config: {
      highlight: (lane) => {
        return true;
      },
    },
    body: [],
  };
  public rowform = false;
  public loadPage = false;

  public totalPagesValue = 0;
  public paginationType: 'next' | 'prev' | 'choose' | 'none' = 'next';
  public dataAttr;

  public line;
  public lineremove;

  public isReadonly = false;
  public isLabeled = false;
  public isRequired = false;
  public isDisabled = false;

  public hideField = false;

  public helperTextValue = '';
  public labelValue = '';

  public valueInput!: string;

  public hasError = false;
  public isValid = false;
  public editControl = false;
  private getUserData: any;

  private errorPopup!: ErrorOverlayClass;

  public properties: any;
  public data: any;
  public _data: any;

  public dynamicFormService!: DynamicFormService;
  public cardInfo: any;
  public inputValue: any;

  private _config: any;
  get config() {
    return this._config;
  }
  set config(value: any) {
    this._config = value;
    this.table.config = this.config;
  }

  private _columns: any;
  get columns() {
    return this._columns;
  }
  set columns(value: any) {
    this._columns = value;
    this.table.columns = this.columns;
  }

  private _details: any;
  get details() {
    return this._details;
  }
  set details(value: any) {
    this._details = value;
    this.table.details = this.details;
  }

  private _body: any = [];
  get body() {
    return this._body;
  }
  set body(value: Array<any>) {
    this._body = value.filter((x) => !x.deleted);
    this.table.body = this._body;
  }

  @Input('cleanUpData')
  set clean(val) {
    this.clearTable();
  }

  @Input()
  set configuration(val) {
    this.fieldConfiguration = val;
  }

  @Input('data')
  set dataFill(val) {
    this._data = val;
  }

  @Input()
  set template(val) {
    if (val) {
      this.templateData = val.form;
      this.properties = val;
      if (val.configuration) this.templateConfig = val.configuration;
    }
  }

  @Input() set field(val) {
    this.fieldItem = val;
  }
  @Input() set require(status: boolean) {
    this.isRequired = status;
  }
  @Input() set disabled(disabled: boolean) {
    this.isDisabled = disabled;
  }
  @Input() set helperText(value: string) {
    this.helperTextValue = value;
  }
  @Input() set label(value: string) {
    this.labelValue = value;
  }
  @Input() set labeled(value: boolean) {
    this.isLabeled = value;
  }
  @Input() set totalPages(totalPages: number) {
    this.totalPagesValue = totalPages;
  }
  @Input('dataAttr') set dataAt(data) {
    this.dataAttr = data;
  }
  @Input() set cardData(data) {
    this.cardInfo = data;
  }
  @Input('gridFormModuleInstance') set gridFormModuleInstanceController(fn) {
    this.gridFormModuleInstance = fn;
  }
  @Input('entityData') set modulesConfig(data) {
    this.data = data;
  }
  @Input() set readonly(value: boolean) {
    this.isReadonly = value;
  }

  controlData;

  @Input('dynamicFormService') set formServiceSetter(dynamicFormService: DynamicFormService) {
    this.dynamicFormService = dynamicFormService;
    this.emmiterFeedback = dynamicFormService.feedbackEmitter;
  }

  @Input()
  set value(val: any) {
    if (val) {
      this.inputValue = [...val];
      this.formatInput(this.inputValue);
    }
  }

  @Input('error')
  set err(error) {
    if (error && error.length > 0) {
      this.hasError = true;
      this.errorPopup.setErrors(error);
    } else {
      this.hasError = false;
      this.errorPopup.setErrors([]);
    }
    this.error = error;
  }

  public emmiterFeedback!: any;
  private subscription;
  public controllData: any;
  public subFormModuleInstance: any;

  @Output('setError') errorStateEmmiter = new EventEmitter();
  @Output('validState') validStatusEmmiter = new EventEmitter();
  @Output('changeValue') changeValueEmmiter = new EventEmitter();
  @Output('selectedPage') selectedPageValueEmmiter = new EventEmitter<number>();

  readonly userService = inject<UserServiceInterface>(USER_SERVICE);

  constructor() {
    const overlay = this.overlay;
    const elementRef = this.elementRef;

    this.errorPopup = new ErrorOverlayClass(overlay);
    this.errorPopup.setPosition(
      elementRef,
      [
        {
          originX: 'start',
          originY: 'top',
          overlayX: 'start',
          overlayY: 'bottom',
        },
      ],
      0,
      0,
      'bottom',
      'start'
    );
  }

  ngOnDestroy(): void {
    this.subscription ? this.subscription.unsubscribe() : '';
  }

  async ngOnInit(): Promise<any> {
    this.subFormModuleInstance = this.dynamicFormService.setFormControlData('');
    if (this.properties?.form.length > 0) {
      this.dynamicFormService.convertSubformsToControlStructure(this.properties.form);
    }
    if (this.fieldItem.auxEntity) {
      const { entityRecoverUrl, entityParameters } = this.fieldItem.auxEntity;
      const params = {
        context: this.cardInfo.context || this.dataAttr.entityKey,
        processId: this.dataAttr.processNumber,
      };
      if (Array.isArray(entityParameters) && entityParameters.length > 0) {
        for (const parameters of entityParameters) {
          const { parameterKey, isMetadata, formKey } = parameters;
          params[parameterKey] = isMetadata
            ? this.dynamicFormService.formControlStructure.formMetadata[formKey]
            : this.dynamicFormService.formControlStructure.fieldControl[formKey];
        }
      }
      this.gridBoxService
        .getDinamicUrl(entityRecoverUrl, params)
        .subscribe((resp) => this.formatInput(resp));
    } else {
      if (this.inputValue) {
        this.formatInput(this.inputValue);
      }
    }
    this.getUserData = this.userService.getUserInfo();
    await this.createTable();

    setTimeout(() => (this.loadPage = true), 200);

    this.fillProperties();
  }

  clearTable() {
    if (this.body) this.body = [];
    this.dataGrid = [];
  }

  formatInput(val) {
    let isObject = false;
    if (val && val.length > 0) {
      const ent = val[0];
      isObject = typeof ent === 'object';
    }

    if (isObject) {
      this.dataGrid = val;
      this.valueInput = val.valueInput;
      this.formatData();
    } else if (!val) {
      this.dataGrid = [];
    } else {
      if (typeof val === 'string') return;

      val.forEach((element) => {
        const gridbox = {
          entityKey: this.fieldConfiguration.entityKey,
          fields: [
            {
              ...this.fieldList[0],
              value: element,
            },
          ],
          edit: false,
          remove: false,
          confirmDelete: false,
        };

        this.dataGrid = [...this.dataGrid, gridbox];

        this.fieldList = [];
        this.newItem().then((resp) => {
          this.fieldList = resp as any;
        });

        this.isValid = false;
        this.hasError = false;
      });
    }
  }

  fillProperties() {
    if (!this.properties) {
      let arrayPrimary: any = [];
      let arraySecondary: any = [];

      if (this.fieldConfiguration.primary)
        if (Array.isArray(this.fieldConfiguration.primary)) {
          this.fieldConfiguration.primary.forEach((element) => arrayPrimary.push(element));
        } else arrayPrimary = [...this.fieldConfiguration.primary];

      if (this.fieldConfiguration.secondary)
        if (Array.isArray(this.fieldConfiguration.secondary)) {
          this.fieldConfiguration.secondary.forEach((element) => arraySecondary.push(element));
        } else arraySecondary = [...this.fieldConfiguration.secondary];

      const prop = {
        form: [{ fields: [[...(arrayPrimary || []), ...(arraySecondary || [])]] }],
      };
      this.properties = prop;
    }
  }

  async createTable() {
    this.fieldList = (await this.newItem()) as any;

    return new Promise((resolve) => {
      if (this.columns && this.details) return resolve(true);

      const columns: any = [];
      const details: any = [];

      this.fieldConfiguration.primary.forEach((element, index) => {
        if (index === 0)
          columns.push({
            name: 'content',
            type: 'action-delete',
            functionDelete: (element) => this.deleteItemGrid(element),
            col: 1,
          });

        if (element.fields) {
          element.fields.forEach((fieldsList) => {
            columns.push(this.fillObject(fieldsList, index));
          });
        } else {
          columns.push(this.fillObject(element, index));
        }
      });

      columns.push({
        name: 'actions',
        label: '',
        type: 'action-flag-to-delete',
        templateRef: this.actionsRender,
        col: 1,
      });

      if (this.fieldConfiguration.secondary)
        this.fieldConfiguration.secondary.forEach((element, index) => {
          if (element.fields)
            element.fields.forEach((fieldsList) =>
              details.push(this.fillObject(fieldsList, index))
            );
          else {
            if (Array.isArray(element))
              element.forEach((fieldsList) => details.push(this.fillObject(fieldsList, index)));
            else details.push(this.fillObject(element, index));
          }
        });

      // this.table.config =
      this.config = {
        highlight: (lane) => {
          return true;
        },
      };
      this.columns = columns;
      this.details = details;
      this.body = this.dataGrid;
      this.table.columns = columns;
      this.table.details = details;
      // this.table.body = this.dataGrid
      return resolve(true);
    });
  }

  fillObject(element, index) {
    return {
      name: element.entityKey,
      label: element.label,
      type: 'data',
      orderDefault: index === 1 ? true : false,
      order: false,
      col: element.size,
      field: element,
    };
  }

  async formatData() {
    let elementTrue = false;
    this.dataGrid.forEach((element, index) => {
      if (element) {
        elementTrue = true;
        element.index = index + 1;
        element.edit = false;
        element.remove = false;
        element.opened = false;
        element.confirmDelete = false;
      }
    });
    if (elementTrue) {
      await this.createTable();
      this.body = this.dataGrid;
    }
  }

  private clearData() {
    const allFields = pipeRamda(pathOrRamda([], [0, 'fields']), flattenRamda)(this.fieldList);

    allFields.forEach((field: any) => {
      if (this.dynamicFormService.formControlStructure?.fieldControl?.[field.entityKey]) {
        this.dynamicFormService.formControlStructure.fieldControl[field.entityKey].value =
          undefined;
      }
    });
  }

  async newItem(): Promise<any[]> {
    this.fieldList = [];
    return new Promise((resolve) => {
      let formFields: any[] = [];

      if (this.templateData) formFields = [...this.templateData];
      else {
        let arrayPrimary: any[] = [];
        let arraySecondary: any[] = [];

        if (this.fieldConfiguration.primary)
          if (Array.isArray(this.fieldConfiguration.primary)) {
            this.fieldConfiguration.primary.forEach((element) => arrayPrimary.push(element));
          } else arrayPrimary = [...this.fieldConfiguration.primary];

        if (this.fieldConfiguration.secondary)
          if (Array.isArray(this.fieldConfiguration.secondary)) {
            this.fieldConfiguration.secondary.forEach((element) => arraySecondary.push(element));
          } else arraySecondary = [...this.fieldConfiguration.secondary];

        formFields = [...(arrayPrimary || []), ...(arraySecondary || [])];
      }

      formFields.forEach((mainData) => {
        if (!mainData.fields) {
          this.rowform = true;
          mainData.value = null;
        } else
          mainData.fields.forEach((fieldList: any) => {
            if (Array.isArray(fieldList)) {
              fieldList.forEach((fieldListByRow) => {
                fieldListByRow.value = null;
                if (fieldListByRow.fields) {
                  fieldListByRow.fields.forEach((element) => {
                    element.value = null;
                    element.fields.forEach((field) => (field.value = null));
                  });
                }
              });
            } else {
              fieldList.value = null;
            }
          });
      });

      const id = uuidV1();
      const classFields = new FieldsGrid(formFields, id);
      setTimeout(() => {
        return resolve(classFields.fields);
      }, 20); // sem o timeout os fields não limpam
    });
  }

  public async newField(): Promise<void> {
    this.fieldList = (await this.newItem()) as any;
    this.hideField = false;
  }

  removeItensToData(data) {
    const finalDataToSend: any = [];
    data.forEach((item) =>
      finalDataToSend.push(
        (({ edit, remove, confirmDelete, index, opened, ...output }) => output)(item)
      )
    );

    this.changeValueEmmiter.emit(finalDataToSend);
  }

  clearInvalidCharacterOrDate(data: Array<any>): Array<any> {
    const newData: any[] = [];
    data.forEach((el) => {
      if (el.type === 'CALENDAR') {
        if (el.value !== '') {
          newData.push(el);
        }
      } else {
        newData.push(el);
      }
    });
    return newData;
  }

  public async addToTable($event, data): Promise<void> {
    const newData = this.clearInvalidCharacterOrDate(data);
    this.hasError = this.validateFields();

    if (this.hasError) return;

    const gridbox = {};
    gridbox['index'] = this.body.length + 1;
    gridbox['id'] = uuidV1();
    gridbox['edit'] = false;
    gridbox['remove'] = false;
    gridbox['opened'] = false;
    gridbox['confirmDelete'] = false;
    gridbox['user'] = this.getUserData.fullname;
    gridbox['createDate'] = moment().unix();
    gridbox['taskId'] = this.dynamicFormService.taskId;

    newData.forEach((mainData) => {
      if (!mainData.fields) gridbox[mainData.entityKey] = mainData.value;
      else
        mainData.fields.forEach((fieldList) => {
          if (Array.isArray(fieldList))
            fieldList.forEach((fieldListByRow) => {
              const fieldControl =
                this.dynamicFormService.formControlStructure.fieldControl[fieldListByRow.entityKey];
              if (fieldControl?.visible)
                gridbox[fieldListByRow.entityKey] = fieldControl?.value ?? fieldListByRow?.value;
            });
          else gridbox[fieldList.entityKey] = fieldList.value;
        });
    });

    const dataToSend = [...this.dataGrid, gridbox];
    this.dataGrid = dataToSend;

    this.removeItensToData(dataToSend);
    this.body = this.dataGrid;

    this.fieldList = (await this.newItem()) as any;

    this.clearData();
  }

  public async editItemGrid($event, gridbox, edit): Promise<void> {
    this.newItem().then(async (resp) => {
      this.fieldList = resp as any;
      const { fieldControl } = this.dynamicFormService.formControlStructure;

      if (edit) {
        this.editControl = true;
        this.dataGrid.forEach((element) =>
          element.id === gridbox.id ? (element.edit = true) : (element.edit = false)
        );

        let hasDependency = false;

        this.fieldList.forEach((mainData) => {
          if (!mainData.fields) {
            if (mainData.isFatherDependency) hasDependency = mainData.isFatherDependency;
            mainData.value = gridbox[mainData.entityKey];
          } else
            mainData.fields.forEach((fieldList) => {
              if (Array.isArray(fieldList))
                fieldList.forEach((fieldListByRow) => {
                  if (fieldListByRow.isFatherDependency)
                    hasDependency = fieldListByRow.isFatherDependency;
                  fieldListByRow.value = gridbox[fieldListByRow.entityKey];
                  fieldControl[fieldListByRow.entityKey].value = gridbox[fieldListByRow.entityKey];
                });
              else {
                if (fieldList.isFatherDependency) hasDependency = fieldList.isFatherDependency;
                fieldList.value = gridbox[fieldList.entityKey];
              }
            });
        });

        // if (hasDependency) this.subFormModuleInstance(null, "value", null);
      } else {
        this.editControl = false;
        this.dataGrid.forEach((element) => (element.edit = false));
      }
    });
  }

  async reIndex() {
    await this.dataGrid.forEach((item, index) => (item.index = index + 1));
  }

  async updateTable($event, data) {
    this.hasError = this.validateFields();
    if (this.hasError) return;

    const gridbox = this.dataGrid.find((item) => item.edit);

    data.forEach((mainData) => {
      if (!mainData.fields) {
        gridbox[mainData.entityKey] = mainData.value;
      } else
        mainData.fields.forEach((fieldList) => {
          if (Array.isArray(fieldList))
            fieldList.forEach((fieldListByRow) => {
              if (!gridbox['lastValue']) gridbox['lastValue'] = {};
              gridbox['lastValue'][fieldListByRow.entityKey] = gridbox[fieldListByRow.entityKey];
              gridbox[fieldListByRow.entityKey] = cloneRamda(
                this.dynamicFormService.formControlStructure.fieldControl[fieldListByRow.entityKey]
                  ?.value
              );
              // gridbox[fieldListByRow.entityKey] = fieldListByRow.value
            });
          else gridbox[fieldList.entityKey] = fieldList.value;
          gridbox['updatedAt'] = gridbox['updatedAt'] ?? moment().unix();
          gridbox['taskId'] = this.dynamicFormService.taskId;
        });
    });

    gridbox.edit = false;
    this.editControl = false;
    await this.reIndex();

    this.body = [];

    setTimeout(() => {
      this.body = this.dataGrid;
    }, 100);

    const dataToSend = this.dataGrid;

    this.removeItensToData(dataToSend);

    this.fieldList = (await this.newItem()) as any;
    this.clearData();
  }

  public async deleteItemGridConfirm($event, content): Promise<void> {
    if (this.editControl) await this.editItemGrid($event, content, false);

    this.paginationType = 'none';
    await waitingTimer(20);

    content.remove = !content.remove;
    this.line = { id: content.id, status: content.remove };
  }

  public async deleteItemGrid(content): Promise<void> {
    this.paginationType = 'none';
    await waitingTimer(20);
    this.lineremove = { id: content.id };
    content.confirmDelete = !content.confirmDelete;

    await waitingTimer(600);

    // this.dataGrid = this.dataGrid.filter((array) => array.id !== content.id);
    this.dataGrid = this.dataGrid.map((array) =>
      array.id === content.id ? { ...array, deleted: true } : { ...array }
    );

    await this.reIndex();

    this.body = this.dataGrid;

    const dataToSend = this.dataGrid;

    this.removeItensToData(dataToSend);

    this.fieldList = (await this.newItem()) as any;

    this.popupFeedController.show(this.templateRemove);
    await waitingTimer(2000);
    this.popupFeedController.close();
  }

  public changeFieldGroup($event: any, group): void {
    const entityKey = $event.entityKey;
    const value = $event.value;

    if (Array.isArray(group.value)) {
      group.value.forEach((key) => (key[entityKey] = value));
    } else {
      group.value = [{ [entityKey]: value }];
    }
    this.subFormModuleInstance(entityKey, 'value', value);
  }

  public changeField($event, field): void {
    this.subFormModuleInstance(field.entityKey, 'error', []);
    this.hasError = false;
    field.value = $event;
    this.subFormModuleInstance(field.entityKey, 'value', field.value);
  }

  public changeFieldGridUnique($event, field): void {
    $event.map((element) => {
      // const canSend = element.config.reduce((acc, value)=> acc && (element[value.entityKey] || element[value.entityKey] === false || element[value.entityKey] === 'false'),true)
      // if (element.canSend) {
      delete (element as any).canSend;
      // field.value = $event;
      // }
    });

    if (Array.isArray($event)) {
      const filterEmptyOrNil = pipeRamda(
        filterRamda((item) => !(isEmptyRamda(item) || isNilRamda(item))),
        ifElseRamda(isEmptyRamda, alwaysRamda(undefined), (v) => v)
      );

      this.subFormModuleInstance(field.entityKey, 'value', filterEmptyOrNil($event));
    } else {
      this.subFormModuleInstance(field.entityKey, 'value', $event);
    }
  }

  public editLine($event, row): void {
    row.edit = !row.edit;
  }

  public getFocus(): void {
    this.mainElement!.nativeElement.focus();
  }

  public copyToClipboard($event, element): void {
    $event.preventDefault();
    $event.stopPropagation();
    navigator.clipboard.writeText(element.inputData.nativeElement.value).then(() => {
      this.popupFeedController.show(this.templateCopy);
      setTimeout(() => this.popupFeedController.close(), 4000);
    });
  }

  public orientation(value: 'next' | 'prev'): void {
    this.paginationType = value;
  }

  public selectedPage(value: number): void {
    this.selectedPageValueEmmiter.emit(value);
  }

  async changeValueTable($event) {
    const lane = $event.lane;
    const obj = $event.montaObj;
    const entityKey = $event.entityKey;

    lane[entityKey] = obj.value;

    this.removeItensToData(this.dataGrid);

    this.fieldList = (await this.newItem()) as any;
  }

  saveUpload($event) {
    const file = $event;
    const context = file.context;
    const entityKey = file.entityKey;
    const value = context; //file.deleted === 1 ? null : context;

    this.fieldList.forEach((mainData) => {
      if (!mainData.fields) {
        if (mainData.entityKey === entityKey) {
          mainData.value = value;
        }
      } else {
        mainData.fields.forEach((fieldList) => {
          if (Array.isArray(fieldList)) {
            fieldList.forEach((fieldListByRow) => {
              if (fieldListByRow.entityKey === entityKey) {
                fieldListByRow.value = value;
              }
            });
          } else {
            if (fieldList.entityKey === entityKey) {
              fieldList.value = value;
            }
          }
        });
      }
    });
  }

  private validateFields() {
    const { fieldControl } = this.dynamicFormService.formControlStructure;
    const hasError = pipeRamda(
      mapRamda(ifElseRamda(hasRamda('fields'), propRamda('fields'), (i) => i)),
      flattenRamda,
      mapRamda((fields: any) => ({ ...fields, hasError: false })),
      (fields) => {
        const localFields = [...fields];
        if (Array.isArray(fields)) {
          fields.map((field) => {
            // const innerError = false;
            const localFieldControl = fieldControl[field.entityKey];
            if (
              !localFieldControl?.value &&
              localFieldControl?.visible &&
              localFieldControl?.required
            ) {
              if (typeof localFieldControl.value === 'boolean') {
                if (String(localFieldControl.value).length === 0) {
                  this.subFormModuleInstance(localFieldControl.fieldKey, 'error', [
                    'Campo Obrigatório!',
                  ]);
                  field.hasError = true;
                }
              } else {
                this.subFormModuleInstance(localFieldControl.fieldKey, 'error', [
                  'Campo Obrigatório!',
                ]);
                field.hasError = true;
              }
            }
          });
        }
        return localFields;
      },
      reduceRamda((acc, cur) => acc || (cur.required && cur.hasError), false)
    )(this.fieldList);
    return hasError;
  }
  orderTable(e) {}
}
